import { Theme, makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
  container: {
    margin: "12px 0 4px",
    padding: "24px",
    display: "flex",
    gap: "12px",
    alignItems: "center",
    background: "#FAFBFC",
    borderRadius: "12px",
  },
  points: {
    display: "grid",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    placeItems: "center",
    color: "#FFFFFF",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(14),
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1,
  },
  availablePoints: {
    background: "#0ABF52",
  },
  unavailablePoints: {
    background: "#CF1B1B",
  },
  text: {
    fontFamily: "Lato",
    color: "#45547C",
    fontSize: theme.typography.pxToRem(14),
  },
  underline: {
    textDecoration: "underline",
  },
  error: {
    textAlign: "center",
    fontFamily: "Lato",
    color: "#CF1B1B",
    fontSize: theme.typography.pxToRem(14),
  },
  purchaseButton: {
    margin: "12px 0 -4px",
    width: "100%",
    height: "auto",
    background: "transparent",
    borderRadius: "6px",
    border: "none",
    color: "inherit",
    padding: "8px 0",
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
      textTransform: "none",
    },
  },
}));
